import React, { useEffect, useContext, useState } from "react";
import "../../../../assets/FLPSignConfirm/scss/Flp_Confirm.scss";
import Continue from "../../../../assets/FLPSignConfirm/img/continue.png";
import { usePageLoad } from "../../../../Hooks/usePageLoad";
import { getPageName } from "../../../../Constants/PageNames";
import { queryString } from "../../../../Utility/QueryString";
import VisitorParamsContext from "../../../../Contexts/VisitorParams";
import WhiteLogo from "../../../../assets/FLPSignConfirm/img/logo-white-1.png";
import Footer from "./Footer";
import LoaderFlp from "./LoaderFlp";
import PrivacyPolicy from '../Common/PrivacyPolicy';

const WelcomePage = ({
  uuid,
  allFollowupData,
  onContinue,
  userData,
  loaderWelcome,
  flpSource
}) => {
  const splitName = localStorage.getItem("split_name");
  const flp_source = allFollowupData.atp_sub6;
  const { savePageLoad, calledOnce } = usePageLoad();
  const { visitorParameters } = useContext(VisitorParamsContext);
  const [showPrivacy, setShowPrivacy] = useState(false);


  const modalClick = (clickValue) => {
    switch (clickValue) {
        case "showPrivacy": {
            setShowPrivacy(true);
            break;
        }
        case "exitPrivacy": {
            setShowPrivacy(false);
            break;
        }
      }
    }
  useEffect(() => {
    if (!!uuid && !calledOnce) {
      const data = {
        uuid,
        page_name: getPageName("flp_sign_reconfirm_lp_visited"),
        status: "visited",
        source: flpSource,
      };
      (async () => {
        await savePageLoad(
          uuid,
          data,
          "visited_status",
          splitName,
          queryString,
          visitorParameters.data
        );
      })();
    }
  }, [uuid, calledOnce]);

  return (
    <>
      <div className="Flp_signConfirm">
        <LoaderFlp loaderWelcome={loaderWelcome} />

        <section className="banner  ">
          <div className="container">
            <div>
              <div className="brand">
                <div className="logo pt-3">
                  <a href="index.html">
                    {" "}
                    <img src={WhiteLogo} height={60} alt="" />
                  </a>
                </div>
              </div>
            </div>
            <div>
              <div className="banner-inner">
                <div className="row  ">
                  <div className="col-lg-7 col-md-12 col-sm-12">
                    <div className="banner-caption">
                      <div className=" mt-lg-0 mt-md-2 mt-sm-2 mt-4">
                        <div className="overflow-hidden ">
                          <h1 className="fw-bold  drop-in text-lg-start text-md-center text-sm-center text-center mb-3 ">
                            <small style={{ fontSize: 20 }}>
                              Hello {userData.txtFName},
                            </small>
                            <br />
                            Welcome Back
                          </h1>
                        </div>
                        <div className="overflow-hidden">
                          <p className="  py-2 drop-in-2 subtext text-lg-start text-md-center text-sm-center text-center">
                            We’re picking up from where you left off. We just need a
                            few more information to complete your application.
                          </p>
                          <p className="t-outer-line  pt-0 mb-2 drop-in-2 subtext text-lg-start text-md-center text-sm-center text-center">
                            It’s quick and easy, just share the final details, and
                            we’ll handle the rest.
                          </p>
                        </div>
                      </div>
                      <div className="mt-lg-3 overflow-hidden tex-lg-start text-md-start text-sm-center text-center mt-lg-3 mt-md-3 mt-sm-0 mt-2">
                        <div>
                          <div className="row">
                            <div className="col-lg-11">
                              <div className="overflow-hidden ">
                                <div className="drop-in-2">
                                  <button className="btn-comm2 px-5 fw-semibold pulse2 my-2 mx-2 chooseLender  " onClick={onContinue}>
                                    {" "}
                                    Continue My Claim
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="overflow-hidden">
                          <div className=" mt-3 list-style-wrap drop-in-2">
                            <p style={{ fontSize: 12 }}>
                              By clicking Continue, you agree to reuse your earlier
                              details and consents, including your e-signature. We may
                              ask for any missing information, and all permissions
                              will be refreshed to help us move your claim forward.
                              For more details, see our  {" "}
                              <a className="privacy-link"
                                onClick={() => modalClick("showPrivacy")}>
                                Privacy Policy.
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12  ">
                    <div className="man-art d-lg-block d-md-none d-sm-none d-none">
                      <img src={Continue} alt="" />
                    </div>
                  </div>
                  <div className="text-center man-art-mobile d-lg-none d-md-block d-sm-block d-block">
                    <img src={Continue} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
        {/* End Banner */}

      </div >
     <PrivacyPolicy showPrivacy={showPrivacy} modalClick={modalClick} />
      
    </>


  )
}
export default WelcomePage;